var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-tabs',{attrs:{"pills":""}},[_c('b-tab',{attrs:{"title":"Oustanding","active":""}},[_c('IndexNotYetPayment')],1),_c('b-tab',{attrs:{"title":"List Create"}},[_c('IndexPayment')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }